<div class="title-bar" [class]="customClass">
  <div class="title-bar-left">
    <div class="title-bar-text">
      <h1 class="title-bar-title">{{ title }}</h1>
      <p class="title-bar-description" *ngIf="description">{{ description }}</p>
    </div>
  </div>
  
  <div class="title-bar-right" *ngIf="showButton || buttonContent || showDropdowns">
    <!-- Dropdowns Section -->
    <div class="title-bar-dropdowns" *ngIf="showDropdowns && (dropdowns.length > 0 || dropdownContent)">
      <!-- Custom dropdown content projection -->
      <ng-container *ngIf="dropdownContent; else defaultDropdowns">
        <ng-container [ngTemplateOutlet]="dropdownContent"></ng-container>
      </ng-container>
      
      <!-- Default simple dropdowns -->
      <ng-template #defaultDropdowns>
        <app-simple-dropdown
          [options]="dropdown.options"
          *ngFor="let dropdown of dropdowns; let i = index; trackBy: trackByIndex"
          [selectedValue]="dropdown.selectedValue"
          [title]="dropdown.title"
          [disabled]="dropdown.disabled || false"
          (selectionChange)="onDropdownChange(i, $event)">
        </app-simple-dropdown>
      </ng-template>
    </div>

    <!-- Custom button content projection -->
    <ng-container *ngIf="buttonContent; else defaultButton">
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </ng-container>
    
    <!-- Default button using AddButtonComponent -->
    <ng-template #defaultButton>
      <app-add-button
        *ngIf="showButton"
        [buttonText]="buttonText"
        [variant]="buttonVariant"
        [size]="buttonSize"
        [iconType]="buttonIconType"
        [customIcon]="buttonIcon"
        [disabled]="disabled"
        [ariaLabel]="ariaLabel"
        (buttonClick)="onButtonClick()">
      </app-add-button>
    </ng-template>
  </div>
</div>
